import { addFilter } from "mutations/addFilterMutation";
import { completeStep } from "mutations/completeStepMutation";
import { gotoPreviousStep } from "mutations/gotoPreviousStepMutation";
import { removeFilter } from "mutations/removeFilterMutation";
import { updateDirtyState } from "mutations/updateDirtyStateMutation";
import { updateArticleMatchesPage } from "mutations/updateArticleMatchesPageMutation";

const resolvers = {
  Mutation: {
    addFilter,
    completeStep,
    gotoPreviousStep,
    removeFilter,
    updateDirtyState,
    updateArticleMatchesPage,
  },
};

export default resolvers;



// WEBPACK FOOTER //
// ./src/apollo/resolvers.js